import { render } from "./ErrorsLog.vue?vue&type=template&id=2105bcf9&scoped=true"
import script from "./ErrorsLog.vue?vue&type=script&lang=js"
export * from "./ErrorsLog.vue?vue&type=script&lang=js"

import "./ErrorsLog.vue?vue&type=style&index=0&id=2105bcf9&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2105bcf9"]])

export default __exports__